module.exports = __webpack_public_path__ + "static/media/mr.561a002c.svg";